import { useMemo } from 'react'
import { meetingNotepadKey } from '../notepad-key'
import { useMeetingNotepadDocument } from '../use-meeting-notepad'
import type { MeetingViewModel } from '../use-meeting-view-model'
import { NotepadEditor } from './notepad'

interface MeetingViewNotepadPanelProps {
  model: MeetingViewModel
}

/**
 * The meeting's Notes tab, live or finished: the same notes the footer
 * notepad edits from other views, given the whole body instead of a panel over
 * the chat input.
 */
export function MeetingViewNotepadPanel({ model }: MeetingViewNotepadPanelProps) {
  const key = meetingNotepadKey(model)
  const serverIds = useMemo(
    () => ({ audioSessionId: model.audioSessionId ?? undefined, audioNoteId: model.audioNoteId ?? undefined }),
    [model.audioSessionId, model.audioNoteId],
  )
  const { initialNotes, serverMarkdown, updateNotes } = useMeetingNotepadDocument(key, serverIds)

  return (
    <section aria-label="Notepad" className="flex flex-col px-5 pb-5 pt-1">
      <NotepadEditor
        key={key}
        initialNotes={initialNotes}
        serverMarkdown={serverMarkdown}
        updateNotes={updateNotes}
        isCollapsed={false}
      />
    </section>
  )
}
